<template>
  <div class="myCollect">
     <div class='banxin'>

       <div class="content">
          <div>
              <div v-if="total>0">
                <!-- <h3 >{{classifyName}}</h3> -->
                <ProductList :productList='productList'></ProductList>
              </div>
              <div v-else class="noproduct">
                <p class="fs20 font-color-999">该分类没有商品～</p>
              </div>
          </div>
          <el-pagination
            v-if="total>0"
            :current-page="page"
            :page-size="size"
            @current-change="handleCurrentChange"
            background layout='total, prev, pager, next' :total='total'>
          </el-pagination>
       </div>

     </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { listSearchMixin } from '@/config/mixin'
  import {mapGetters} from 'vuex'
  import ProductList from '@/components/base/productList'
  export default{
    name: 'myCollect',
    mixins: [listSearchMixin],
    components: {
      ProductList
    },
    data(){
      return{
        productList:[],
        total:100,
        page:1,
        size:8,
      }
    },
    computed: {
      ...mapGetters([
        'userInfo' // 用户信息
      ])
    },
    created() {
      this.getUserCollectProduct();
    },
    methods:{
      getUserCollectProduct(){
        let self = this
        let params = {
            url: api.userCollectProduct+"?page="+this.page+"&limit="+this.size,
            method: 'GET',
          }
          self.sendReq(params, (res) => {
            if (res.success) {
               console.log(res)
              self.productList = res.data.content
              self.total = res.data.totalElements;
              // if (res.data.content.length < 1) {
              //   self.noProduct = true
              // }
            } else {
                  self.$message({
                      message: res.message,
                      type: 'warning'
                  })
              }
          })
      },
      handleCurrentChange(val){
        this.page = val;
        this.getUserCollectProduct();
      }
    }
  }
</script>

<style lang="scss" scoped>
.myCollect{
    width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  // padding-bottom: 143px;
  text-align: center;
  .banxin {
    // width: 1252px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: white;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 20px;
      }
      .keyword {
        margin: 0 20px;
        color: #ff7800;
      }
      .arrow {
        background-image: url('../../../../static/image/xiangyou@2x.png');
        width: 5px;
        height: 10px;
      }
    }
    .banner{
        width: 100%;
        height: 356px;
        margin-bottom: 25px;
    }
    .content{
        background-color: #FFFFFF;
        width: 100%;
        padding: 0 0px 30px;
        box-sizing: border-box;
        .sort {
        width: 100%;
        height: 63px;
        line-height: 27px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;
        color: #666666;
		padding-left:50px;
        .default {
          margin-left: 20px;
          cursor: pointer;
        }
        .sales {
          cursor: pointer;
          img{
            width: 9px;
            height: 16px;
            vertical-align: middle;
          }
        }
        .price {
          display: flex;
          margin: 0 20px;
          cursor: pointer;
          .arr {
            vertical-align: middle;
            width: 12px;
            margin-left: 3px;
            .up {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-bottom-color: #999999;
            }
            .down {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-top-color: #999999;
              margin-top: 3px;
            }
          }
        }
        .active{
            color: #FF7800;
            .arr{
              .high{
                border-top-color: #FF7800;
              }
              .low{
                border-bottom-color: #FF7800;
              }
            }
          }
       }
       h3{
           font-size: 24px;
           font-weight: bold;
           margin-bottom: 30px;
       }
       .noproduct{
          width: 100%;
          text-align: center;
          padding: 200px 0;
       }
      >>>.el-pagination{
        text-align: right;
        .el-pager{
          li:not(.disabled):hover{
            color: #FF7800;
          }
          li:not(.disabled).active{
            background-color: #FF7800;
          }
          li:not(.disabled).active:hover{
            color: #F4F4F5;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/myCollect/myCollect.vue